/** Component that search for user based on phone number */
import React, { useState, useEffect } from 'react';
import { Form, Select, Spin, Empty } from 'antd';
import { useLazyQuery } from '@apollo/react-hooks';
import { useDebounce } from 'utilities';
import { SEARCH_CUSTOMERS } from 'services';

const { Item } = Form;
const { Option } = Select;

const SearchCustomers = ({ setSelectedKeys, selectedKeys, forwardedRef }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const [searchCustomers, { loading, data }] = useLazyQuery(SEARCH_CUSTOMERS, {
    variables: {
      customerPhoneNumber: debouncedSearchTerm,
    },
  });

  useEffect(() => {
    if (debouncedSearchTerm) {
      searchCustomers();
    }
  }, [debouncedSearchTerm, searchCustomers]);

  const onChange = (value) => {
    if (!value) {
      setSelectedKeys(null);
    }
  };

  return (
    <Select
      loading={loading}
      onSearch={(searchValue) => setSearchTerm(searchValue)}
      onSelect={(value) => setSelectedKeys(value)}
      showSearch
      showArrow={false}
      filterOption={false}
      allowClear={true}
      notFoundContent={
        !debouncedSearchTerm ? null : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )
      }
      value={selectedKeys}
      onChange={onChange}
      placeholder="Search by phone"
      style={{ width: 188, marginBottom: 8, display: 'block' }}
      ref={forwardedRef}
    >
      {debouncedSearchTerm ? (
        loading ? (
          <Option value={null} disabled style={{ textAlign: 'center' }}>
            <Spin tip="Loading Customers..." />
          </Option>
        ) : (
          data &&
          data.searchCustomers.map((customer) => (
            <Option key={customer.id} value={customer.id}>
              {customer.name}
            </Option>
          ))
        )
      ) : null}
    </Select>
  );
};

export default SearchCustomers;
